/* dev-filtered-collection.js */

const FC_PARAM = 'filter';

/**
 * Reads the card's filter map: { "calming": 1, "cellular": 4 }.
 * The value is the product's 1-based position inside that filter's curated list.
 * @param {HTMLElement} card
 * @returns {Record<string, number>}
 */
function readFilterMap(card) {
  if (!card.dataset.fc) return {};
  try {
    return JSON.parse(card.dataset.fc);
  } catch (e) {
    return {};
  }
}

function applyFilter(section, filterButtons, filter) {
  let activeButton = null;

  filterButtons.forEach((b) => {
    const isActive = b.dataset.filter === filter;
    b.classList.toggle('is-active', isActive);
    if (isActive) activeButton = b;
  });

  // Fall back to "all" when the requested filter has no matching button
  if (!activeButton) {
    filter = 'all';
    filterButtons.forEach((b) => {
      const isActive = b.dataset.filter === 'all';
      b.classList.toggle('is-active', isActive);
      if (isActive) activeButton = b;
    });
  }

  // A filter with a curated product list controls both membership and order.
  // Without one, membership falls back to matching the product's tags.
  const isCurated = activeButton != null && activeButton.dataset.curated === 'true';

  const cards = section.querySelectorAll('.filtered-collection__card-wrap');
  let visibleCount = 0;

  cards.forEach((card) => {
    let isVisible;

    if (filter === 'all') {
      isVisible = true;
      card.style.order = '';
    } else if (isCurated) {
      const position = readFilterMap(card)[filter];
      isVisible = position !== undefined;
      card.style.order = isVisible ? String(position) : '';
    } else {
      const tags = card.dataset.tags ? card.dataset.tags.split('|') : [];
      isVisible = tags.includes(filter);
      card.style.order = '';
    }

    card.hidden = !isVisible;
    if (isVisible) visibleCount += 1;
  });

  const emptyMessage = section.querySelector('[data-fc-empty]');
  if (emptyMessage) emptyMessage.hidden = visibleCount > 0;

  const grid = section.querySelector('.filtered-collection__products');
  if (grid) grid.hidden = visibleCount === 0;

  return filter;
}

function initFilteredCollection(section) {
  if (section.dataset.fcInit) return;
  section.dataset.fcInit = '1';

  const filterButtons = section.querySelectorAll('.filtered-collection__filter-btn');
  if (!filterButtons.length) return;

  // Apply filter from URL param on load (e.g. ?filter=joint), shareable links
  const params = new URLSearchParams(window.location.search);
  const initial = (params.get(FC_PARAM) || '').trim().toLowerCase();
  if (initial) applyFilter(section, filterButtons, initial);

  section.addEventListener('click', (e) => {
    const btn = e.target.closest('.filtered-collection__filter-btn');
    if (!btn) return;

    const filter = applyFilter(section, filterButtons, btn.dataset.filter);

    // Keep the URL in sync so the current filter is shareable / bookmarkable
    const url = new URL(window.location.href);
    if (filter === 'all') {
      url.searchParams.delete(FC_PARAM);
    } else {
      url.searchParams.set(FC_PARAM, filter);
    }
    window.history.replaceState({}, '', url);
  });
}

// Initial load — defer guarantees DOM is ready
document.querySelectorAll('.filtered-collection').forEach(initFilteredCollection);

// Theme Editor: section re-rendered on settings change
document.addEventListener('shopify:section:load', (e) => {
  const section = e.target.querySelector('.filtered-collection');
  if (section) initFilteredCollection(section);
});
